module.exports = __webpack_public_path__ + "static/media/tdc.5d48aaa6.svg";